var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyPredictionSaveAs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2109_107)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2109_107)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(9 9)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2109_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9581 12.5848L19.4174 10.0442C19.3002 9.92701 19.1565 9.84108 19.0002 9.7942V9.75201H10.2502C9.97368 9.75201 9.75024 9.97545 9.75024 10.252V21.752C9.75024 22.0286 9.97368 22.252 10.2502 22.252H21.7502C22.0268 22.252 22.2502 22.0286 22.2502 21.752V13.2911C22.2502 13.0255 22.1456 12.7723 21.9581 12.5848ZM14.0002 10.877H18.0002V12.502H14.0002V10.877ZM21.1252 21.127H10.8752V10.877H13.0002V13.002C13.0002 13.2786 13.2237 13.502 13.5002 13.502H18.5002C18.7768 13.502 19.0002 13.2786 19.0002 13.002V11.2176L21.1252 13.3426V21.127ZM16.0002 14.9083C14.7581 14.9083 13.7502 15.9161 13.7502 17.1583C13.7502 18.4005 14.7581 19.4083 16.0002 19.4083C17.2424 19.4083 18.2502 18.4005 18.2502 17.1583C18.2502 15.9161 17.2424 14.9083 16.0002 14.9083ZM16.0002 18.4083C15.3096 18.4083 14.7502 17.8489 14.7502 17.1583C14.7502 16.4676 15.3096 15.9083 16.0002 15.9083C16.6909 15.9083 17.2502 16.4676 17.2502 17.1583C17.2502 17.8489 16.6909 18.4083 16.0002 18.4083Z",
    fill: "black",
    fillOpacity: 0.45
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2109_107",
    x: 0,
    y: 0,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2109_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2109_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2109_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2109_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyPredictionSaveAs);
export default __webpack_public_path__ + "static/media/weekly-prediction-save-as.ef8524fe71cfe30a14e44c1064aa18a9.svg";
export { ForwardRef as ReactComponent };